import { SCENE_INTERACTION } from '../../../constants/scene';
import { WEBRTC_EVENTS } from '../../../constants/webrtc';
import { SOCKET_EVENTS } from '../../../socket/Events';
import { SCENE_EVENTS } from '../../MVC/Model';
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS, states } from '../constants';
import { AntMediaControllerCamera } from './AntMediaControllerCamera';
import { AntMediaControllerScreen } from './AntMediaControllerScreen';

export const CONTROLLERS = { CAMERA: 'CAMERA', SCREEN: 'SCREEN' };

export class UnifiedAntMediaController {
  constructor({ model, token, roomNameBox, videoMode, myVideoElement }) {
    this.model = model;
    model.streamController = this;
    this.roomNameBox = `room-${this.model.getCurrentSceneName() + this.model.config.worldId}`;
    this.roomNameBox = this.roomNameBox.replace(/ /g, "");
    this.cameraController = new AntMediaControllerCamera(model, {}, {}, token, this.roomNameBox, videoMode, myVideoElement, this.successCallback, this.errorCallback, this); // Starts with audio true
    this.screenController = new AntMediaControllerScreen(model, {}, {}, token, this.roomNameBox, videoMode, myVideoElement, this.successCallback, this.errorCallback, this); // Starts with audio false
    this.isCameraAudioMuted = false; // Tracks the mute state of the camera
    this.isScreenAudioMuted = true;  // Tracks the mute state of the screen
    this.audioOwner = 'camera';

    this.ignoredInfoTypes = ["ping", "pong", "bitrateMeasurement", "roomInformation", "streamsList"];
    this.ignoredInfoTypesTrack = ["ping", "pong", "bitrateMeasurement"];
    this.roomOfStream = {};

    this.model.addEventListener(SOCKET_EVENTS.DISCONNECT, () => {
      this.cameraController.leaveRoom();
      this.screenController.leaveRoom();
    });
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.PUBLISH_STARTED, () => {
      this.applyAudioOwner();
    });

    this.model.addEventListener(SCENE_INTERACTION.USER_SCENE_CHANGED, () => {
      this.roomNameBox = `room-${this.model.getCurrentSceneName() + this.model.config.worldId}`;
      this.roomNameBox = this.roomNameBox.replace(/ /g, "");
      this.cameraController.roomNameBox = this.roomNameBox;
      this.screenController.roomNameBox = this.roomNameBox;
    });

    this.model.addEventListener(SCENE_INTERACTION.USER_LEAVES_SCREEN_SHARE, () => {
      this.screenController.closeStream();
      this.screenController.leaveRoom();
      this.screenController.removeFromChair();
      $("#screen-share-menu").removeClass("is-active");
      this.applyAudioOwner();
    });
    this.model.addEventListener(SCENE_INTERACTION.USER_LEAVES_SEAT, () => {
      this.cameraController.closeStream()
      this.cameraController.leaveRoom()
      this.cameraController.removeFromChair()
    });
    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_MIC_ON, () => {
      this.applyAudioOwner();
    });
    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_MIC_OFF, () => {
      this.applyAudioOwner();
    });
    this.model.addEventListener(SCENE_EVENTS.USER_SCREEN_SHARE_TURN_MIC_OFF, () => {
      if (typeof this.model.view?.handleAudioOff === 'function') {
        this.model.view.handleAudioOff();
        return;
      }
      this.model.userWantsAudio = false;
      this.model.iStream.audio = false;
      this.applyAudioOwner();
    });
    this.model.addEventListener(SCENE_EVENTS.USER_SCREEN_SHARE_TURN_MIC_ON, () => {
      if (typeof this.model.view?.handleAudioOn === 'function') {
        this.model.view.handleAudioOn();
        return;
      }
      this.model.userWantsAudio = true;
      this.model.iStream.audio = true;
      this.applyAudioOwner();
    });
    this.model.addEventListener(WEBRTC_EVENTS.WEBRTC_CALL_CANCELED, () => {
      if (this.model.view.iSitOnChair()) {
        this.cameraController.joinRoom();
      }
      if (this.model.view.iSitOnScreenStream()) {
        this.screenController.roomJoinedCallback = () => {
          this.screenController.publish();
        }
        this.screenController.joinRoom();
      }
    });
    this.model.addEventListener(WEBRTC_EVENTS.WEBRTC_SOMEONE_REJECTED_YOUR_CALL, () => {
      if (this.model.view.iSitOnChair()) {
        this.cameraController.joinRoom();
      }
      if (this.model.view.iSitOnScreenStream()) {
        this.screenController.roomJoinedCallback = () => {
          this.screenController.publish();
        }
        this.screenController.joinRoom();
      }
    });
    this.model.addEventListener(WEBRTC_EVENTS.HUNG_UP_CALL, () => {
      if (this.model.view.iSitOnChair()) {
        this.cameraController.joinRoom();
      }
      if (this.model.view.iSitOnScreenStream()) {
        this.screenController.roomJoinedCallback = () => {
          this.screenController.publish();
        }
        this.screenController.joinRoom();
      }
    });
    this.model.addEventListener(WEBRTC_EVENTS.WEBRTC_VIDEO_ONE_ON_ONE, () => {
      this.cameraController.leaveRoom();
      this.screenController.leaveRoom();
    });
    this.model.addEventListener(WEBRTC_EVENTS.ANSWER_CALL, () => {
      this.cameraController.leaveRoom();
      this.screenController.leaveRoom();
    });
    this.model.addEventListener(SOCKET_EVENTS.DISCONNECT, () => {
      this.cameraController.leaveRoom();
      this.screenController.leaveRoom();
      const chairItem = this.model.view.iSitOnChair();
      if (chairItem) {
        const callback = () => {
          chairItem.getState();
          if (chairItem.state.occupied && chairItem.state.me) {
            this.cameraController.joinRoom();
            this.model.onTakeSeat(chairItem.dbConfig);
            this.model.removeEventListener(SOCKET_EVENTS.SOCKET_CONNECT_SUCCESS, callback)
          }
        }
        this.model.addEventListener(SOCKET_EVENTS.SOCKET_CONNECT_SUCCESS, callback)
      }
    });

    this.streams = {
      "CAMERA": {},
      "SCREEN": {},
    }

  }
  liveAudioTracks(controller) {
    const stream = controller?.webRTCAdaptor?.mediaManager?.localStream;
    if (!stream) {
      return [];
    }
    return stream.getAudioTracks().filter((track) => track.readyState === 'live');
  }

  screenOwnsAudio() {
    return this.liveAudioTracks(this.screenController).length > 0;
  }

  setCameraMic(enabled) {
    if (this.liveAudioTracks(this.cameraController).length === 0) {
      return;
    }
    if (enabled) {
      this.cameraController.unmuteLocalMic();
      this.isCameraAudioMuted = false;
      return;
    }
    const userMuted = this.model.userWantsAudio === false;
    // A second getUserMedia here can end the chair mic. While the screen owns
    // audio, only disable the chair track so voice can return when the share stops.
    this.cameraController.muteLocalMic({ monitor: userMuted && !this.screenOwnsAudio() });
    this.isCameraAudioMuted = true;
  }

  setScreenMic(enabled) {
    if (this.liveAudioTracks(this.screenController).length === 0) {
      return;
    }
    if (enabled) {
      this.screenController.unmuteLocalMic();
      this.isScreenAudioMuted = false;
      return;
    }
    this.screenController.muteLocalMic({ monitor: false });
    this.isScreenAudioMuted = true;
  }

  applyAudioOwner() {
    const wantsAudio = this.model.userWantsAudio !== false;
    if (this.screenOwnsAudio()) {
      this.audioOwner = 'screen';
      this.setCameraMic(false);
      this.setScreenMic(wantsAudio);
      return;
    }
    this.audioOwner = 'camera';
    this.setCameraMic(wantsAudio);
  }

  streamIsMine(streamid) {
    const streamCamera = this.cameraController.publishStreamId;
    const streamScreen = this.screenController.publishStreamId;
    if (streamid === streamCamera || streamid === streamScreen) {
      return true;
    }
    return false
  }

  startCamera() {
    return new Promise(async (resolve, reject) => {
      try {
        // Cleanup tour mode streams before starting meeting mode camera
        if (this.model.tourStreamController) {
          try {
            await this.model.tourStreamController.cleanupAllStreams();
          } catch (error) {
            console.error("Error cleaning up tour mode streams:", error);
            // Continue anyway to not block meeting mode start
          }
        }
        
        await this.cameraController.connect();
        resolve(); // Resolve the promise after successful operations
      } catch (error) {
        console.error("Error starting camera:", error);
        reject(error); // Reject the promise in case of an error
      }
    });
  }
  setStreamsList = (list) => {
    this.streamsList = [...this.streamsList, ...list];
    this.streamsList = this.streamsList.filter((item, index) => this.streamsList.indexOf(item) === index);
  }
  cameraStarted = () => {
    return this.cameraController.webRTCAdaptor !== null;
  }
  cameraJoinRoom = () => {
    if (this.cameraController.state === states.JOINED_ROOM) {
      return;
    }
    this.cameraController.joinRoom(this.roomNameBox)
  }
  screenJoinRoom = () => {
    this.screenController.joinRoom(this.roomNameBox)
  }
  screenStarted = () => {
    return this.screenController.webRTCAdaptor !== null;
  }
  userSetNewCamera = () => {
    this.cameraController.newCameraSelected();
  }

  startScreen(cameraId, microphoneId) {
    let data = {
      video: { deviceId: { exact: cameraId } },
      audio: { deviceId: { exact: microphoneId }, echoCancellation: true },
    };
    if (microphoneId === "default") {
      data.audio = true;
    }
    if (!microphoneId) {
      data = {
        ...data,
        audio: true,
      }
    }
    if (cameraId && microphoneId) {
      this.screenController.mediaConstraints = data;
    } else {
      this.screenController.mediaConstraints = this.screenController.displayCaptureConstraints();
    }

    return new Promise(async (resolve, reject) => {
      try {
        // Cleanup tour mode streams before starting meeting mode screen share
        if (this.model.tourStreamController) {
          try {
            await this.model.tourStreamController.cleanupAllStreams();
          } catch (error) {
            console.error("Error cleaning up tour mode streams:", error);
            // Continue anyway to not block meeting mode start
          }
        }
        
        await this.screenController.connect();
        resolve(); // Resolve the promise after successful operations
      } catch (error) {
        console.error("Error starting camera:", error);
        reject(error); // Reject the promise in case of an error
      }
    });
  }

  isInRoom() {
    return this.screenController.state === states.JOINED_ROOM || this.cameraController.state === states.JOINED_ROOM;
  }
  isScreenSharing() {
    return this.screenController.state === states.JOINED_ROOM;
  }

  isOnlyOneSharing() {
    const first = this.screenController.state === states.JOINED_ROOM;
    const second = this.cameraController.state === states.JOINED_ROOM;
    if ((first && !second) || (!first && second)) {
      return true;
    }
    return false;
  }

  removeRemoteVideo = (streamId, type) => {
    if (this.streamIsMine(streamId)) {
      return;
    }
    var player = document.getElementById("player-" + streamId);
    const video = document.getElementById("remoteVideo-" + streamId);

    if (type === CONTROLLERS.CAMERA) {
      if (video != null) {
        delete this.streams["CAMERA"][streamId];
        video.srcObject = null;
        if (this.streams["SCREEN"][streamId]) {
          video.srcObject = this.streams["SCREEN"][streamId];
          return;
        }
        document.getElementById("players").removeChild(player);
        this.model.dispatchEvent({ type: "REMOVE_STREAM", data: { id: streamId } });
      }
    }
    if (type === CONTROLLERS.SCREEN) {
      if (video != null) {
        delete this.streams["SCREEN"][streamId];
        video.srcObject = null;
        if (this.streams["CAMERA"][streamId]) {
          video.srcObject = this.streams["CAMERA"][streamId];
          return;
        }
        document.getElementById("players").removeChild(player);
        this.model.dispatchEvent({ type: "REMOVE_STREAM", data: { id: streamId } });
      }
    }

    return;
    console.log("removeRemoteVideo", streamId, type);
    // const video = document.getElementById("remoteVideo-" + streamId);
    if (video && video.hasAttribute(`data-init-test`)) {
      console.log(video.hasAttribute(`data-init-test`));
      video.removeAttribute(`data-init-test`);
      return;
    }
    if (video != null) {
      var player = document.getElementById("player-" + streamId);
      video.srcObject = null;
      document.getElementById("players").removeChild(player);
      this.model.dispatchEvent({ type: "REMOVE_STREAM", data: { id: streamId } });
    }
    // this.webRTCAdaptor.stop(streamId);
    // this.streamsList = this.streamsList.filter(item => item !== streamId);
  }


  // createRemoteVideo = (streamId) => {
  //   const player = document.createElement("div");
  //   player.className = "col-sm-3";
  //   player.id = "player-" + streamId;
  //   player.innerHTML = '<video class="myVideo" id="remoteVideo-' + streamId + '"autoplay playsinline></video>';
  //   player.childNodes[0]
  //   document.getElementById("players").appendChild(player);
  //   return player.childNodes[0];
  // }

  createRemoteVideo = (streamId, stream) => {
    return new Promise((resolve, reject) => {
      const player = document.createElement("div");
      player.id = "player-" + streamId;
      player.innerHTML = '<video class="myVideo" id="remoteVideo-' + streamId + '" autoplay playsinline></video>';
      const videoElement = player.childNodes[0];
      document.getElementById("players").appendChild(player);
      videoElement.srcObject = stream;
      // Ensure the video is ready to play through
      videoElement.addEventListener('loadeddata', () => {
        videoElement.play().then(() => {
          videoElement.setAttribute('canplaythrough', 'true');
          resolve(videoElement);
        }).catch(e => {
          console.error('Error in playing video:', e);
          reject(e);
        });
      });

      // Error handling
      videoElement.addEventListener('error', (e) => {
        console.error('Error in video playback:', e);
        reject(e);
      });
    });
  }


  playVideo(type, obj, token) {
    this.streams[type][obj.streamId] = obj.stream;
    if (this.streamIsMine(obj.streamId)) {
      return;
    }
    let video = document.getElementById("remoteVideo-" + obj.streamId);
    if (video === null) {
      this.createRemoteVideo(obj.streamId, obj.stream).then(videoElement => {
        // Video is ready, create THREE.VideoTexture or other operations
        this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.VIDEO_CREATED });
        // Use videoTexture in your Three.js scene
      }).catch(error => {
        console.error('Error creating video element:', error);
      });
    }
    switch (type) {
      case CONTROLLERS.CAMERA:
        this.cameraController.webRTCAdaptor.getStreamInfo(obj.streamId);
        this.cameraController.webRTCAdaptor.enableAudioLevel(obj.stream, obj.streamId);
        break;
      case CONTROLLERS.SCREEN:
        this.screenController.webRTCAdaptor.getStreamInfo(obj.streamId);
        this.screenController.webRTCAdaptor.enableAudioLevel(obj.stream, obj.streamId);
        break;
    }
    this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.PLAY_STARTED });
  }

  toggleMute() {
    const turnOn = this.model.userWantsAudio === false;
    this.model.userWantsAudio = turnOn;
    this.model.iStream.audio = turnOn;
    this.applyAudioOwner();
  }

  checkVideoTrackStatus = (info, obj, type) => {
    // let streamList;
    // if (type === CONTROLLERS.CAMERA) {
    //   streamList = this.cameraController.webRTCAdaptor.streamsList;
    // }
    // if (type === CONTROLLERS.SCREEN) {
    //   streamList = this.screenController.webRTCAdaptor.streamsList;
    // }
    this.streamList && this.streamList.forEach((item) => {
      const video = document.getElementById("remoteVideo-" + item);
      if (video != null && !video.srcObject.active) {
        this.webRTCAdaptor.stop(item);
        // this.controller.removeRemoteVideo(item);
        this.webRTCAdaptor.play(item, null, this.roomNameBox);
      }
      if (video === null) {
        if (this.streamIsMine(item))
          return;
        this.webRTCAdaptor.play(item, null, this.roomNameBox);
      }
    });
  }


  successCallback = (info, obj, type) => {
    // !this.ignoredInfoTypes.includes(info) && console.log(type, " : ", info)
    if (!this.ignoredInfoTypesTrack.includes(info)) {
      this.model.antMediaTrackMessages.push({ [info]: obj });
      if (this.model.antMediaTrackMessages.length > 60) {
        this.model.antMediaTrackMessages.shift();
      }
    }
    if (info == "initialized") {
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.INITIALISED })
      if (this.playOnly) {
        this.isCameraOff = true;
        // this.handleCameraButtons();
      }

      // switch (type) {
      //   case CONTROLLERS.CAMERA:
      //     this.cameraController.joinRoom(this.roomNameBox)
      //     break;
      //   case CONTROLLERS.SCREEN:
      //     this.screenController.joinRoom(this.roomNameBox)
      //     break;
      // }
    }

    else if (info == "trackList") {
      console.log(type, "trackList", obj)
    }
    else if (info == "joinedTheRoom") {
      const room = obj.ATTR_ROOM_NAME;
      this.roomOfStream[obj.streamId] = room;
      this.publishStreamId = obj.streamId;

      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.JOIN_ROOM_SUCESS })
      this.streamsList = obj.streams;

      if (this.streamsList.length > 0) {
        this.dominantSpeakerFinderId = setInterval(() => {
          // this.webRTCAdaptor.getSoundLevelList(this.streamsList);
        }, 200);
      }

    }
    else if (info == "newStreamAvailable") {
      console.log()
      this.playVideo(type, obj);
      if (this.dominantSpeakerFinderId == null) {
        this.dominantSpeakerFinderId = setInterval(() => {
          // this.webRTCAdaptor.getSoundLevelList(this.streamsList);
        }, 200);
      }
    }
    else if (info == "publish_started") {
      //stream is being published
      // If user selected screen share delayed video texture so we need to recreate it
      console.debug("publish started to room: " + this.roomOfStream[obj.streamId]);
      if (this.videoMode === "screen") {
        this.model.dispatchEvent({ type: "USER_STARTED_SCREEN_SHARE_PUBLISH" })
      }
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.PUBLISH_STARTED })
      // this.onPublishEnableOrDisableVideo(true);
    }
    else if (info == "publish_finished") {

    }
    else if (info == "screen_share_stopped") {
      $("#stopScreenShare").trigger("click");
      this.screenController.leaveRoom();
      // this.model.killStream($("#screenVideoANT")[0].srcObject);
    }
    else if (info == "gotSoundList") {
      // this.findDominantSpeaker(obj);
    }
    else if (info == "browser_screen_share_supported") {
      return
      this.screen_share_checkbox.disabled = false;
      this.camera_checkbox.disabled = false;
      this.screen_share_with_camera_checkbox.disabled = false;
      console.log("browser screen share supported");
      this.browser_screen_share_doesnt_support.style.display = "none";
    }
    else if (info == "leavedFromRoom") {
      this.dominantSpeakerFinderId = null;
    }
    else if (info == "closed") {
      //console.log("Connection closed");
      if (typeof obj != "undefined") {
        console.log("Connecton closed: "
          + JSON.stringify(obj));
      }
    }
    else if (info == "play_started") {
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.PLAY_STARTED });
    }
    else if (info == "play_finished") {
      console.log("play_finished");
      this.removeRemoteVideo(obj.streamId, type);
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.PLAY_FINISHED });
    }
    else if (info == "streamInformation") {
      const video = document.getElementById(`remoteVideo-${obj.streamId}`);
      const { streamInfo } = obj;
      console.log("streamInfo", obj)
      if (video) {
        video.setAttribute('stream-width', streamInfo[0].streamWidth);
        video.setAttribute('stream-height', streamInfo[0].streamHeight);
        this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.TEST_FOR, data: obj })
      }
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.STREAM_INFO, data: obj })
    }
    else if (info == "roomInformation") {
      // this.streamsList = obj.streams;
      this.checkVideoTrackStatus(null, this.streamsList, type);

    }
    else if (info == "data_channel_opened") {
      console.log("Data Channel open for stream id", obj);
      this.isDataChannelOpen = true;
    }
    else if (info == "data_channel_closed") {
      console.log("Data Channel closed for stream id", obj);
      this.isDataChannelOpen = false;
      // if (this.state === states.JOINED_ROOM) {
      //   this.joinRoom();
      // }
    }
    else if (info == "data_received") {
      console.log(obj)
      this.img.src = obj;
      // this.handleNotificationEvent(obj);
    }
    else if (info == "speaking_but_muted") {
      if (!this.mutedAlertPresent) {
        this.mutedAlertPresent = true
        $("#notification").fadeIn("slow");
        $(".dismiss").click(function () {
          $("#notification").fadeOut("slow");
          this.mutedAlertPresent = false;
        });

        setTimeout(() => {
          $("#notification").fadeOut("slow");
          this.mutedAlertPresent = false;
        }, 3000)
      }
    }
    else if (info == "session_restored") {
      // this.handleCameraButtons();
      // this.startAnimation();
      console.log(info + "notification received");
    }
  }
  errorCallback = (error, message) => {
    // Implement error callback logic
    this.model.hideLoading();
  }

  closeCamera() {
    this.cameraController.leaveRoom();
    this.applyAudioOwner();
  }

  closeScreen() {
    this.screenController.leaveRoom();
    this.applyAudioOwner();
  }

  /**
   * Cleanup all streams from both camera and screen controllers
   * Returns a Promise that resolves when all streams are closed
   * This should be called before switching to tour mode
   */
  cleanupAllStreams() {
    return new Promise(async (resolve) => {
      try {
        // Cleanup both controllers in parallel
        const cleanupPromises = [
          this.cameraController.cleanupStreams(),
          this.screenController.cleanupStreams()
        ];
        
        await Promise.all(cleanupPromises);
        
        // Additional cleanup: clear any remaining stream references
        this.streams = {
          "CAMERA": {},
          "SCREEN": {},
        };
        
        resolve();
      } catch (error) {
        console.error("Error during stream cleanup:", error);
        // Resolve anyway to not block tour mode start
        resolve();
      }
    });
  }
  // Implement additional methods as needed
}
